"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFutureReminders = exports.getArchivedReminders = exports.getActiveReminders = exports.getRemindersByType = exports.isFuture = exports.isArchived = exports.isActive = void 0;
const moment_1 = __importDefault(require("moment"));
const lodash_1 = __importDefault(require("lodash"));
const sortReminders = reminders => reminders.sort((a, b) => Date.parse(a.monTime) - Date.parse(b.monTime));
const isActive = (reminder, date) => {
  const startMoment = (0, moment_1.default)(reminder.startDate);
  const endMoment = reminder.endDate ? (0, moment_1.default)(reminder.endDate) : null;
  const hasStarted = startMoment.isSameOrBefore(date);
  const hasNotEnded = endMoment ? endMoment.isSameOrAfter(date) : true;
  return hasStarted && hasNotEnded;
};
exports.isActive = isActive;
const isArchived = (reminder, date) => {
  const endMoment = reminder.endDate ? (0, moment_1.default)(reminder.endDate) : null;
  return endMoment ? endMoment.isBefore(date) : false;
};
exports.isArchived = isArchived;
const isFuture = (reminder, date) => (0, moment_1.default)(reminder.startDate).isAfter(date);
exports.isFuture = isFuture;
const getRemindersByType = (reminders, type) => {
  const TODAY = (0, moment_1.default)().startOf("day");
  const filteredReminders = lodash_1.default.filter(reminders, reminder => type(reminder, TODAY));
  return sortReminders(filteredReminders);
};
exports.getRemindersByType = getRemindersByType;
const getActiveReminders = reminders => (0, exports.getRemindersByType)(reminders, exports.isActive);
exports.getActiveReminders = getActiveReminders;
const getArchivedReminders = reminders => (0, exports.getRemindersByType)(reminders, exports.isArchived);
exports.getArchivedReminders = getArchivedReminders;
const getFutureReminders = reminders => (0, exports.getRemindersByType)(reminders, exports.isFuture);
exports.getFutureReminders = getFutureReminders;